
















































import Vue from 'vue'
import moment from 'moment'
import sha1 from 'sha1'
import { WECHAT_APPID,WECAHT_NAME,IMG_URL } from '@/utils/constants'
import { wxShare } from '@/utils/wxApi'
import request from '@/utils/request'
// import videoPlayer from './videoPlayer.vue'
import pdfView from '@/views/content_manage/pdf_view.vue'

import { Toast } from 'vant'
export default Vue.extend({
  components: { pdfView },
  data() {
    return {
      id: '' as any,
      data: {}
    }
  },
  async mounted() {
    this.id = 3
    await this.getData()

  },
  methods: {
    getData() {

      const params = {
        categoryId: this.id,
        limit: 1
      }
      request.get('/api/column/rest_article/show_list', params).then((data) => {
        if (data.length > 0) {
          // this.data = data[0]
          const articleId = data[0].id
          request.get(`/api/column/rest_article/${articleId}`).then((data) => {
            this.data = data
            // @ts-ignore
            if (this.data.enclosure) {
              // @ts-ignore
              const arr1 = this.data.enclosure.split('/')
              const str1 = arr1[arr1.length - 1]
              const arr2 = str1.split('.')
              // @ts-ignore
              this.data.enclosureStr = arr2[0]
              // @ts-ignore
              this.data.enclosureType = this.data.enclosure.split('.')[1]
            }
            this.initWeixin()

          })

        }
      })
    },
    async initWeixin() {  
       let title = '一周天气预报'
      //@ts-ignore
      title = this.data.title
      const url = window.location.href
      const timestamp = moment().valueOf()
      const nonceStr = 'tongzhouwechat'
      const jsapiTicket = await request.get('/api/account/office_account/jsapi_ticket')
      console.log('jsapiTicket', jsapiTicket)
      const params = `jsapi_ticket=${jsapiTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
      console.log('params', params)
      const signature = sha1(params)
      const obj = {
        appId: WECHAT_APPID,
        nonceStr: nonceStr,
        signature: signature,
        timestamp: timestamp,
      }

      let shareData = {
        title: WECAHT_NAME,
        desc: title,
        imgUrl: IMG_URL,
        link: url,
      };
      wxShare(obj, shareData);
    },
  },
  filters: {
    dtFormat(timestamp: number) {
      const time = moment(timestamp)
      return time.format('YYYY-MM-DD')
    },
  },
})
